import { ReviewRequestPresenter } from '@/presentation/presenters/reviewRequest/reviewRequestPresenter'
import { ReviewRequestViewModel } from '@/presentation/viewmodels/reviewRequest/reviewRequestViewModel'

export function useReviewRequestPresenter(
  presenter: ReviewRequestPresenter = new ReviewRequestPresenter(new ReviewRequestViewModel())
) {
  return {
    reviewRequestList: presenter.reviewRequestList,
    freeDescription: presenter.freeDescription,
    reviewJudgeId: presenter.reviewJudgeId,
    reviewJudgeStatus: presenter.reviewJudgeStatus,
    isLoading: presenter.isLoading,
    error: presenter.error,
    setFreeDescription: presenter.setFreeDescription,
    setReviewRequestData: presenter.setReviewRequestData,
    getReviewRequestList: presenter.getReviewRequestList,
    postRegisterEntry: presenter.postRegisterEntry
  }
}
